import dataConstants from "../../constants/dataConstants";
import FormStep from "../models/formModels/MultiStepForm/formStep.model";

export enum OrderStepActions {
  ADD_CLINICIAN = "addClinician",
  ADD_EXISTING_CLINICIAN = "addExistingClinician",
  REMOVE_CLINICIAN = "removeClinician",
  DISABLE_FIELD = "disableField",
  RESET_ORDER_STEPS = "resetOrderSteps",
}

function OrderStepsReducer(
  state: {
    orderSteps: FormStep[];
  },
  action: {
    type:
      | OrderStepActions.ADD_CLINICIAN
      | OrderStepActions.REMOVE_CLINICIAN
      | OrderStepActions.ADD_EXISTING_CLINICIAN
      | OrderStepActions.RESET_ORDER_STEPS
      | OrderStepActions.DISABLE_FIELD;
    payload: number | string;
  }
) {
  if (action.type === OrderStepActions.ADD_CLINICIAN) {
    return {
      ...state,
      orderSteps: state.orderSteps.map((step) => {
        if (step.stepTitle === "Additional Information") {
          return {
            ...step,
            subSteps: step.subSteps?.map((subStep) => {
              let fields = subStep.fields;
              fields = fields.map((field) => {
                return { ...field, addMore: null };
              });
              fields.push({
                ...dataConstants.clinician,
                remove: {
                  ...dataConstants.clinician.remove,
                  index: fields.length,
                },
              });

              return {
                ...subStep,
                fields,
              };
            }),
          };
        }
        return step;
      }),
    };
  }
  if (action.type === OrderStepActions.ADD_EXISTING_CLINICIAN) {
    return {
      ...state,
      orderSteps: state.orderSteps.map((step) => {
        if (step.stepTitle === "Additional Information") {
          return {
            ...step,
            subSteps: step.subSteps?.map((subStep) => {
              let clinicians = Array.from(
                { length: Number(action.payload) },
                () => dataConstants.clinician
              ).map((item, index, self) => {
                if (index + 1 !== self.length)
                  return { ...item, remove: undefined, addMore: undefined };
                return { ...item, remove: undefined };
              });
              return {
                ...subStep,
                fields: clinicians,
              };
            }),
          };
        }
        return step;
      }),
    };
  }

  if (action.type === OrderStepActions.REMOVE_CLINICIAN) {
    return {
      ...state,
      orderSteps: state.orderSteps.map((step) => {
        if (step.stepTitle === "Additional Information") {
          return {
            ...step,
            subSteps: step.subSteps?.map((subStep) => {
              return {
                ...subStep,
                fields: subStep.fields
                  .filter((subField, index) => index !== action.payload)
                  .map((item, index, self) => {
                    if (index === self.length - 1)
                      return {
                        ...item,
                        addMore: dataConstants.clinician.addMore,
                      };
                    return item;
                  }),
              };
            }),
          };
        }
        return step;
      }),
    };
  }

  if (action.type === OrderStepActions.DISABLE_FIELD) {
    return {
      ...state,
      orderSteps: state.orderSteps.map((step) => {
        return {
          ...step,
          fields: step.fields.map((field) => ({
            ...field,
            disabled: field.name === action.payload,
          })),
          subSteps: step.subSteps?.map((subStep) => {
            return {
              ...subStep,
              fields: subStep.fields.map((field) => ({
                ...field,
                disabled: field.name === action.payload,
              })),
            };
          }),
        };
      }),
    };
  }
  if (action.type === OrderStepActions.RESET_ORDER_STEPS) {
    // Reset only the "Additional Information" step to remove added clinicians
    return {
      ...state,
      orderSteps: state.orderSteps.map((step) => {
        if (step.stepTitle === "Additional Information") {
          return {
            ...step,
            fields: step.fields.map((field) => ({
              ...field,
              disabled: false,
            })),
            subSteps: step.subSteps?.map((subStep) => {
              return {
                ...subStep,
                fields: subStep.fields.map((field) => ({
                  ...field,
                  disabled: false,
                })),
              };
            }),
          };
        }
        return step;
      }),
    };
  }

  return state;
}

export default OrderStepsReducer;
